import React from 'react';
import styled from 'styled-components';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const Container = styled.div`
  padding: 16px 16px 0 16px;
  margin: 0 -16px;
  height: ${window.innerHeight - 173}px;
  background-color: ${p4Tokens.colorNeutralBackground1};
`;

const SidebarContainer = styled.div`
  padding: 40px 16px 16px 2px;
  margin: 0;
  height: ${window.innerHeight - 50}px;
  width: 300px;
  background-color: ${p4Tokens.colorNeutralBackground1};
  overflow-y: scroll;
`;

const OverviewContainer = (props) => {
  return props.sidebar ? <SidebarContainer {...props} /> : <Container {...props} />;
};

export default OverviewContainer;
